import React, { useEffect } from 'react';
import { Job } from '@ais-ui/websockets';
import { useReportContext } from './ReportContext';
import { useManageReportProcessing } from './useManageReportProcessing';
import { useTimeZoneContext } from '@ais-ui/utils';
import { useGetReport } from '@ais-ui/websockets';

/**
 * Headless component that loads report data when a job is selected.
 * This allows report data (table, overlay, legend) to be loaded
 * without navigating away from the report list.
 */
export const ReportDataLoader = React.memo(() => {
  const { selectedJob, setReportDetails, setHasLoaded, setIsWaiting } =
    useReportContext();
  const { timeZone } = useTimeZoneContext();

  // Fetch report details
  const { data: report } = useGetReport(
    (selectedJob as Job)?.uuid,
    timeZone
  );

  // Load report processing (table, overlay, etc.)
  const reportResult = useManageReportProcessing(
    (selectedJob as Job)?.uuid,
    true // zoom to report
  );

  // Update report details in context
  useEffect(() => {
    if (report) {
      setReportDetails(report);
    }
  }, [report, setReportDetails]);

  // Update loading state
  useEffect(() => {
    if (reportResult) {
      setHasLoaded(true);
      setIsWaiting(false);
    } else {
      setHasLoaded(false);
      setIsWaiting(true);
    }
  }, [reportResult, setHasLoaded, setIsWaiting]);

  // This component doesn't render anything - it just handles data loading
  return null;
});

ReportDataLoader.displayName = 'ReportDataLoader';
